export default {
  namespaced: true,

  state: () => ({
    reviews: {
      data: [],
      links: {},
      meta: {},
    },
    review: '',
    isLoading: false,
    sourceList: [
      {
        title: 'Miniapoly (default)',
        value: 'miniapoly',
      },
      {
        title: 'Tokopedia',
        value: 'tokopedia',
      },
      {
        title: 'Shopee',
        value: 'shopee',
      },
    ],
    reviewByList: [
      {
        title: 'Pembeli E-Commerce',
        value: 'buyer',
      },
      {
        title: 'Pemilik Registry',
        value: 'receiver',
      },
    ],
    labelForm: {
      product: {
        title: 'Produk',
        description: ['Produk tidak dapat diubah setelah review dibuat'],
      },
      source: {
        title: 'Sumber',
        description: [],
      },
      name: {
        title: 'Nama User',
        description: [],
      },
      user: {
        title: 'User Miniapoly',
        description: [],
      },
      star: {
        title: 'Rating',
        description: [],
      },
      review: {
        title: 'Kelebihan',
        description: [],
      },
      complaint: {
        title: 'Kekurangan',
        description: [],
      },
      visibility: {
        title: 'Visibilitas',
        description: ['Review publik akan ditampikan di halaman Feed Miniapoly. Nonaktifkan agar review hanya ditampilkan di halaman produk terkait'],
      },
      media: {
        title: 'Video dan Foto',
        description: [],
      },
      title: {
        title: 'Judul',
        description: [],
      },
      label: {
        title: 'Label',
        description: [],
      },
      order: {
        title: 'Urutan',
        description: [],
      },
      highlight: {
        title: 'Hightlight',
        description: ['Atur sebagai highlight agar review ditampilkan di halaman utama Miniapoly'],
      },
    },
  }),

  mutations: {
    SET_REVIEWS_LIST(state, payload) {
      state.reviews = payload
    },
    SET_REVIEW(state, payload) {
      state.review = payload
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
    RESET_REVIEWS_LIST(state) {
      state.reviews = {
        data: [],
        links: {},
        meta: {},
      }
    },
  },

  actions: {
    // get
    async getReviewsList({ commit }, { page = null } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = '/v1/admin/products-reviews'

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_REVIEWS_LIST', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getReview({ commit }, { reviewId }) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/products/${reviewId}/show`

        const response = await this._vm.$http.get(url)

        commit('SET_REVIEW', response.data.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    // create
    async createReview({ commit }, { data = null, idProduct = null }) {
      try {
        const url = `/v1/admin/products/${idProduct}/reviews`

        const datas = {
          star: data.star,
          review: data.review,
          complaint: data.complaint,
          is_publish: data.is_publish,
          source: data.source === 'miniapoly' ? null : data.source,
        }

        if (data.highlight) {
          datas.title = data.title
          datas.label = data.label
          datas.order = parseInt(data.order, 0)
        } else {
          datas.title = null
          datas.label = null
          datas.order = null
        }

        if (data.name) datas.name = data.name
        if (data.user_id) datas.user_id = data.user_id
        if (data.media_id.length) datas.media_id = data.media_id

        const response = await this._vm.$http.post(url, datas)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Review!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Review!',
        }, { root: true })

        return false
      }
    },
    // edit
    async updateReview({ commit }, { reviewId, data }) {
      try {
        const url = `/v1/admin/products/${reviewId}/reviews`

        const datas = {
          star: data.star,
          review: data.review,
          complaint: data.complaint,
          is_publish: data.is_publish,
          source: data.source === 'miniapoly' ? null : data.source,
        }

        if (data.highlight) {
          datas.title = data.title
          datas.label = data.label
          datas.order = parseInt(data.order, 0)
        } else {
          datas.title = null
          datas.label = null
          datas.order = null
        }

        if (data.name) datas.name = data.name
        if (data.user_id) datas.user_id = data.user_id
        if (data.media_id.length) {
          datas.media_id = data.media_id
        } else {
          datas.media_id = []
        }

        const response = await this._vm.$http.put(url, datas)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Review!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Review!',
        }, { root: true })

        return false
      }
    },
    // delete
    async deleteReview({ commit, dispatch }, { reviewId }) {
      try {
        const url = `/v1/admin/products/${reviewId}/reviews`

        const response = await this._vm.$http.delete(url)

        dispatch('getReviewsList')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Review!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Review!',
        }, { root: true })

        return error
      }
    },
  },
}
